import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-08-10'
        tag='Mercari'
        title='Prohibited Mercari Items - Items that will get you banned from Mercari'
      >
        <p>
          Mercari is a growing marketplace that attracts new shoppers and sellers daily. Having your Mercari account
          suspended after establishing your seller profile and building your rapport with customers can be stressful. To
          avoid having your account be at risk for suspension, be sure to learn more about the prohibited Mercari items,
          which we'll be discussing in this blog.
        </p>

        <h3>What can get your Mercari account suspended?</h3>

        <p>
          While some activities can seem normal to you, Mercari might have some rules against them. So if you haven't
          read the Terms of Service, it's not uncommon for a seller to disobey the guidelines.{' '}
        </p>

        <p>Mercari will remove users who:</p>
        <ul>
          <li>List or sell prohibited items</li>
          <li>Engage in prohibited conduct</li>
          <li>Violate the Terms of Service multiple times</li>
          <li>Have questionable activity on their account</li>
        </ul>

        <h3>Why Mercari has a Prohibited Item list</h3>

        <p>
          Almost all online marketplaces like Poshmark, Amazon, and eBay list prohibited items that users can't sell or
          list. For Mercari, these items include:
        </p>
        <ul>
          <li>Illegal items</li>
          <li>Tobacco product</li>
          <li>Drugs</li>
          <li>Alcohol</li>
          <li>
            FDA restricted items such as vitamins, diet products, home remedies, and homemade cosmetics (anything
            ingestible)
          </li>
          <li>Counterfeit goods - items in violation of copyright (ex., fake designer clothing and accessories)</li>
          <li>Weapons or anything that can be a possible safety hazard</li>
          <li>Items with inflated prices listed to profit from a tragedy (ex. Fire, flood, etc.)</li>
          <li>Items used for identity theft or scammers</li>
          <li>Animals</li>
          <li>Trafficked materials</li>
          <li>Financial products (ex. bonds, stocks, etc.)</li>
          <li>Dropshipping items</li>
          <li>Items that promote racism, hatred, violence, and discrimination</li>
          <li>Sexually explicit items (ex., Sex toys, and fetish items)</li>
          <li>Products that contain a virus, malware, or spyware</li>
          <li>
            Stolen goods - if the purchased item is reported as stolen, you may receive a demand for the return of the
            possession from the victim, and the item may also get confiscated according to the regulations of the Code
            of Criminal Procedure (Act no. 131 of 1948)
          </li>
        </ul>

        <p>
          Disclaimer: this is not the complete list, so be sure to keep updated with any changes in Mercari's prohibited
          item policy.
        </p>

        <h3>Consequences of selling a prohibited item on Mercari</h3>

        <p>
          Selling any product under the prohibited list is forbidden on most e-commerce websites. If you get your
          account suspended because of any of these products, be sure to revise your listings before you get suspended
          from other platforms like Etsy, Amazon, or eBay as well.
        </p>

        <h3>Removal of the item</h3>

        <p>
          If you've received a warning message from Mercari because you've listed a prohibited item or engaged in any
          prohibited conduct, then be wary because this can lead to temporary suspensions, account restrictions, or
          termination, depending on the severity of the warning or number of prior warnings received.{' '}
        </p>

        <p>
          You can reach out to the customer support team if you feel that this warning message might be a mistake. It is
          essential to note the item ID found in the message you received about the removed listing.
        </p>

        <h3>Temporarily Suspension of Account</h3>

        <p>
          Keeping its buyers safe is a priority for Mercari. This being the case, if the company noticed unusual
          activity on your account, it would suspend you. The security team will look into what the violation was and
          lock your account in the meantime.
        </p>

        <p>
          Another reason why Mercari might suspend or restrict your account is that they protect buyers from suspicious
          sellers. If you have a high number of cancellations or return transactions on the platform, Mercari can
          restrict your account until it investigates the problem.
        </p>

        <p>You can check the Mercari return policy guide if you have any questions regarding that.</p>

        <h3>Permanent Ban of the Account</h3>

        <p>
          If you receive a notice about an indefinite suspension, Mercari has banned your account. You can be
          permanently suspended from the platform if you commit serious violations such as selling illegal items,
          committing fraud, and repeating a violation of the Terms of Service.
        </p>

        <p>
          When you are suspended indefinitely, you will still be able to complete your transaction and request your
          remaining balance. To get unbanned, file an appeal by reaching out to customer service to get your account
          back if you think Mercari made a mistake. However, if you are found guilty, then you will need to say goodbye
          to the marketplace.
        </p>

        <h3>How To Free Your Mercari Account</h3>

        <p>
          To resolve the account suspension issue, you must contact Mercari customer service. If you need help, follow
          these steps to get in touch with them:
        </p>
        <ol>
          <li>Go to the Contact Us page</li>
          <li>Select the Account option</li>
          <li>Select My account was limited</li>
          <li>
            Pick one of the provided reasons why your account was limited:
            <ul>
              <li>My account was limited for identity verification</li>
              <li>My account was limited for unusual activity</li>
              <li>My funds are on hold</li>
              <li>My account was limited for the prohibited item(s) or conduct</li>
              <li>Fill in the form under the Still need help option</li>
              <li>
                Be sure to explain in detail what the issue is and provide images and if applicable. Now we understand
                how frustrating it can be. It is important to keep in mind that Mercari has a high volume of inquiries,
                and it can take the reps a while to respond.{' '}
              </li>
            </ul>
          </li>
        </ol>

        <p>
          As a seller getting your account suspended is no easy thing to handle. This is why big closet sellers often
          enlist the help of automation software to ensure that their listings don't violate the platform's terms of
          service. OneShop is a great software to get you started with. It has an easy-to-use interface and readily
          customizable tools. Without worry, you can leave the manual and time-consuming tasks so you can focus on more
          important things to grow your business. OneShop also functions as your virtual assistant that works 24/7 to
          improve your reach by automating shares, follows, and more!
        </p>

        <p>
          Try it for yourself, register for free, and enjoy a 7-day trial with no commitment or credit card required.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
